
import { defineComponent } from "vue";
import { mdiAccountGroup, mdiChat } from "@mdi/js";
import AppIcon from "@/components/AppIcon.vue";

import { mapGetters, mapMutations } from "vuex";

export default defineComponent({
  components: {
    AppIcon,
  },
  computed: {
    ...mapGetters({
      isLobby: "getIsLobby",
    }),
  },
  methods: {
    ...mapMutations({
      toggleParty: "TOGGLE_PARTY",
      toggleChat: "TOGGLE_CHAT",
    }),
  },
  setup() {
    return { mdiAccountGroup, mdiChat };
  },
});
